import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    padding: theme.spacing(4, 2),
    boxSizing: 'border-box',
    borderRadius: 8,
    [theme.breakpoints.only('xs')]: {
      padding: theme.spacing(4, 2),
    },
  },
  bordered: {
    border: `1px dashed ${theme.palette.divider}`,
  },
  iconCircle: {
    alignItems: 'center',
    backgroundColor: '#C5A561',
    borderRadius: '50%',
    color: '#FFFFFF',
    display: 'flex',
    height: 80,
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    width: 80,
    '& .MuiSvgIcon-root': {
      fontSize: 40,
      color: '#FFFFFF',
    },
    '& svg': {
      fontSize: 40,
      width: 40,
      height: 40,
      color: '#FFFFFF',
      fill: 'currentColor',
    },
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  caption: {
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
    marginBottom: theme.spacing(3),
    maxWidth: '100%',
    width: '100%',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
  },
}))

export default useStyles
